<template>
    <div class="animation-container">
        <div ref="animation"></div>
    </div>
</template>

<script>

    import bodymovin from 'lottie-web';
    import * as AnimationData from '../../animations/donating-thankyou.json';

    export default {

        mounted: function() {
            this.initAnimation()
        },

        methods: {
            initAnimation: function ()
            {
                this.animation = bodymovin.loadAnimation({
                    container: this.$refs.animation,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    animationData: AnimationData.default
                })
            }
        }
    }
</script>
<style lang="scss" scoped>

    .animation-container{
        margin-top: -165px;
        margin-bottom: -120px;

        @media only screen and (max-width: 769px) {
            margin-top: -50px;
            margin-bottom: 0;
        }
    }

</style>